export default "__VITE_ASSET__SLmrm5sd__"